import {Dispatch, useState} from 'react';
import {UiLongTask} from 'types/long-task';

export type UseUILongTaskReturnType = {
    clearLongTask: () => void;
    longTask: UiLongTask | undefined;
    setLongTask: Dispatch<UiLongTask | undefined>;
};

type UseLongTaskFunction = (
    props?: UseLongTaskFunctionProps,
) => UseUILongTaskReturnType;
type UseLongTaskFunctionProps = {
    defaultLongTask?: UiLongTask;
};

/**
 * Responsibility:
 * - Manage state of long task
 * - Manage simple methods such as clearLongTask
 */
const useUILongTask: UseLongTaskFunction = (props) => {
    const [longTask, setLongTask] = useState<UiLongTask | undefined>(
        props?.defaultLongTask,
    );
    const clearLongTask = () => {
        setLongTask(undefined);
    };

    return {clearLongTask, longTask, setLongTask};
};

export default useUILongTask;
